import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ResolveAssetPipe } from '../resolve-asset.pipe';

export type ToolTipDataType = {
	text: string;
	link: string;
	linkText: string;
	dataDetails: SafeHtml;
};

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, ResolveAssetPipe],
	selector: 'sp-tooltip',
	template: `<ng-container>
		<div class="ds-tooltip" [class.has-image]="!!image" [style.visibility]="!image || imageLoaded ? 'visible' : 'hidden'">
			<img *ngIf="image" [src]="image | resolveAsset" class="tooltip-image" (load)="onImageLoaded()" />
			<div class="tooltip-content tw-p-3">
				<p *ngIf="text" class="tw-m-0">{{ text }}</p>
				<ng-content select="[dataDetails]"></ng-content>
				<a *ngIf="link" [href]="link" target="_blank" class="link" (mousedown)="$event.stopPropagation()">
					{{ linkText || 'Learn more' }}
				</a>
				<div *ngIf="contentTemplate">
					<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
				</div>
			</div>
		</div>
	</ng-container>`,
})
export class TooltipComponent {
	@Input() text = '';
	@Input() link: string | undefined;
	@Input() linkText: string | undefined;
	@Input() contentTemplate: TemplateRef<any> | undefined; // use this if you need to style the content of the tooltip
	@Input() image: string | undefined;

	imageLoaded = false;
	onImageLoaded(): void {
		this.imageLoaded = true;
	}
}
